module.exports = __webpack_public_path__ + "img/other-icon-img3.49a268ed.svg";